import { render, staticRenderFns } from "./operatorList.vue?vue&type=template&id=196dc17e&lang=pug"
import script from "./operatorList.vue?vue&type=script&lang=js"
export * from "./operatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports